import { Typography, Anchor } from '@ui/components';
import { Trans } from 'react-i18next';
import { FC } from 'react';

export const PayUAgreements: FC = () => {
  return (
    <Typography className="text-content-weak pb-1" variant="labelMediumBook">
      <Trans
        components={{
          payUPaymentTermsLink: <Anchor />,
          privacyPolicyLink: <Anchor />,
        }}
        i18nKey="ONBOARDING.TOP_UP.PAYU_TERMS"
      />
    </Typography>
  );
};
